/**
 * Dynamic Modal Fetcher
 */
async function openCubeModal(productHandle, variantId) {
  const modalTarget = document.querySelector('#modal_global_atc-target');
  const modalElement = document.querySelector('#modal_global_atc');

  const url = `/products/${productHandle}?variant=${variantId}&section_id=modal_global_atc&v=${Date.now()}`;
  
  try {
    const response = await fetch(url);
    const html = await response.text();
    
    modalTarget.innerHTML = html;
    modalElement.setAttribute('open', ''); 

    if (window.initModalLogic) {
      window.initModalLogic();
    }
  } catch (e) {
    console.error("Modal failed to load", e);
  }
}

window.initModalLogic = function() {
  const container = document.getElementById('modal_global_atc-inner'); 
  if (!container) return;

  const headIn = container.querySelector('.pm-head'); 
  const subIn = container.querySelector('.pm-sub'); 
  const headPv = container.querySelector('.pm-head-preview'); 
  const subPv = container.querySelector('.pm-sub-preview'); 
  const atcBtn = container.querySelector('.pm-atc'); 
  const plaqueFields = container.querySelector('.plaque-customization-container'); 
  const triggers = container.querySelectorAll('.auto-fill-trigger'); 
  const popovers = container.querySelectorAll('.autofill-popover'); 

  const bridgeData = JSON.parse(container.querySelector('#city-data-bridge').textContent);
  const CITY_AUTO_DATA = { 
    baseCity: bridgeData.baseCity, 
    localName: bridgeData.localName, 
    variantCity: bridgeData.variantCity, 
    countryname: bridgeData.countryname, 
    countrycode: bridgeData.countrycode, 
    coordinates: bridgeData.coordinates, 
    cubeScale: bridgeData.cubeScale 
  }; 

  function pushElevarEvent(payload) {
    window.ElevarDataLayer = window.ElevarDataLayer || [];
    window.ElevarDataLayer.push(payload);
  }

  function fireModalViewItem() {
    if (container.dataset.elevarViewItemFired === 'true') return;
    container.dataset.elevarViewItemFired = 'true';

    const product = bridgeData.cube;

    pushElevarEvent({
      event: 'dl_view_item',
      ecommerce: {
        currencyCode: product.currency,
        detail: {
          products: [{
            id: String(product.id),
            product_id: String(product.product_id),
            name: product.title,
            variant: product.variant_title,
            price: String(product.price),
            quantity: 1
          }]
        }
      }
    });
  }

  function fireCustomizeProduct(addOn, type) {
    if (!addOn) return;

    pushElevarEvent({
      event: 'customize_product',
      event_name: 'CustomizeProduct',
      ecommerce: {
        currencyCode: bridgeData.cube.currency,
        customize: {
          products: [{
            id: String(addOn.id),
            product_id: String(addOn.product_id),
            name: addOn.name,
            variant: addOn.variant,
            price: String(addOn.price),
            quantity: 1,
            customization_type: type
          }]
        }
      }
    });
  }

  function getAddOnByVariantId(variantId) {
    if (!variantId) return null;

    return Object.values(bridgeData.addOns).find(addOn => {
      return String(addOn.id) === String(variantId);
    });
  }  

  let selectedPlaqueId = null; 
  let selectedCoverId = null;

  const shippingBridge = container.querySelector('.shipping-cutoff-bridge');
  if (shippingBridge) {
    const CONFIG = JSON.parse(shippingBridge.textContent);
    
    const isHoliday = (date) => CONFIG.holidays.includes(date.toISOString().split('T')[0]);

    const updateShippingTime = () => {
      const now = new Date();
      const berlinNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
      const localNow = new Date();
      const berlinDay = berlinNow.getDay();
      const berlinHour = berlinNow.getHours();
      const berlinMinute = berlinNow.getMinutes();

      let shippingDate = new Date(berlinNow);
      let remainingTime = new Date(berlinNow);

      if (berlinHour < CONFIG.hour || (berlinHour === CONFIG.hour && berlinMinute === 0)) {
        remainingTime.setHours(CONFIG.hour, 0, 0);
      } else {
        remainingTime.setDate(berlinNow.getDate() + 1);
        remainingTime.setHours(CONFIG.hour, 0, 0);
        shippingDate.setDate(berlinNow.getDate() + 1);
      }

      while (isHoliday(shippingDate) || shippingDate.getDay() === 0 || shippingDate.getDay() === 6) {
        shippingDate.setDate(shippingDate.getDate() + 1);
      }

      const localShippingDate = new Date(shippingDate.toLocaleString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }));

      const timeDifference = remainingTime - berlinNow;
      const hoursLeft = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutesLeft = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

      const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let dayTxt = localShippingDate.toDateString() === localNow.toDateString() ? "<b>today</b>" : 
                   localShippingDate.toDateString() === new Date(localNow.getTime() + 86400000).toDateString() ? "<b>tomorrow</b>" : 
                   `on <b>${daysOfWeek[localShippingDate.getDay()]}</b>`;

      let msg = (berlinDay === 6 || berlinDay === 0 || hoursLeft > 12 || hoursLeft < 0)
        ? `Order now and your shipment will be sent out ${dayTxt}.`
        : `Order in the next <b>${hoursLeft}h ${minutesLeft}m</b> and your shipment will be sent out ${dayTxt}.`;

      const display = container.querySelector('.shipping-time');
      if (display) display.innerHTML = msg;
    };

    updateShippingTime();
    setInterval(updateShippingTime, 60000);
  }

  function showPlaqueError(inputElement) { 
    let popup = document.getElementById('plaque-error-popup-modal'); 
    if (!popup) { 
      popup = document.createElement('div'); 
      popup.id = 'plaque-error-popup-modal'; 
      popup.style.cssText = 'background:#ffffff;color:#333333;padding:12px 16px;border-radius:8px;box-shadow:0px 4px 16px rgba(0,0,0,0.15);border:1px solid #e5e5e5;font-size:13px;line-height:1.4;z-index:999999;pointer-events:none;display:none;';
      popup.textContent = 'Emojis (except ❤️) or special symbols cannot be added as plaque text.'; 
      document.body.appendChild(popup); 
    } 
    const rect = inputElement.getBoundingClientRect(); 
    popup.style.position = 'fixed'; 
    popup.style.left = `${rect.left}px`; 
    popup.style.top = `${rect.bottom + 8}px`; 
    popup.style.maxWidth = `${rect.width}px`; 

    if (popup.__showing) return; 
    popup.__showing = true; 
    popup.style.display = 'block'; 
    popup.style.opacity = '1'; 
    setTimeout(() => { popup.style.display = 'none'; popup.__showing = false; }, 3000); 
  } 

  function validateInput(inputElement) { 
    if (!inputElement || !inputElement.value) return;
    const originalValue = inputElement.value; 
    let protectedValue = originalValue.replace(/❤️/g, '___H1___').replace(/❤/g, '___H2___').replace(/♥/g, '___H3___'); 
    let cleaned = protectedValue.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}]/gu, '').replace(/\|/g, '');
    cleaned = cleaned.replace(/___H1___/g, '❤️').replace(/___H2___/g, '❤').replace(/___H3___/g, '♥'); 
    if (originalValue !== cleaned) { 
      inputElement.value = cleaned; 
      showPlaqueError(inputElement); 
    } 
  } 

  function stripFlagEmoji(str) { return str ? str.replace(/[\u{1F1E6}-\u{1F1FF}\u{1F300}-\u{1FAFF}]/gu, '').trim() : ''; }

  function sync() { 
    validateInput(headIn); validateInput(subIn);
    const h = (headIn.value || '').toUpperCase().trim(); 
    const s = (subIn.value || '').toUpperCase().trim(); 
    if (headPv) headPv.textContent = h.replace(/❤️|❤|♥/g, '♡'); 
    if (subPv) { 
      subPv.textContent = s.replace(/❤️|❤|♥/g, '♡'); 
      subPv.style.display = s ? 'block' : 'none'; 
    } 
    atcBtn.disabled = selectedPlaqueId && h.length === 0; 
  } 

  triggers.forEach(btn => { 
    btn.addEventListener('click', (e) => { 
      e.stopPropagation(); 
      const target = container.querySelector(`#popover-${btn.dataset.target}`); 
      popovers.forEach(p => { if(p !== target) p.style.display = 'none' }); 
      target.style.display = target.style.display === 'block' ? 'none' : 'block'; 
    }); 
  }); 

  container.querySelectorAll('.popover-option').forEach(option => { 
    option.addEventListener('click', (e) => { 
      const popover = option.closest('.autofill-popover'); 
      const isSub = popover.id === 'popover-subheadline'; 
      const val = option.dataset.value; 
      if (!isSub) { 
        let txt = ''; 
        if(val === 'cityname') txt = CITY_AUTO_DATA.baseCity; 
        if(val === 'cityname_local') txt = CITY_AUTO_DATA.localName || CITY_AUTO_DATA.baseCity; 
        if(val === 'cityname+countrycode') txt = `${CITY_AUTO_DATA.baseCity}, ${CITY_AUTO_DATA.countrycode}`; 
        if(val === 'countryname') txt = stripFlagEmoji(CITY_AUTO_DATA.countryname); 
        headIn.value = txt.substring(0, 20); 
      } else { 
        let stxt = ''; 
        if(val === 'cityname') stxt = CITY_AUTO_DATA.baseCity; 
        if(val === 'countryname') stxt = stripFlagEmoji(CITY_AUTO_DATA.countryname); 
        if(val === 'areaname') stxt = CITY_AUTO_DATA.variantCity; 
        if(val === 'coordinates') stxt = CITY_AUTO_DATA.coordinates; 
        if(val === 'scale') stxt = CITY_AUTO_DATA.cubeScale ? `1:${CITY_AUTO_DATA.cubeScale}` : ''; 
        if(val === 'none') stxt = ''; 
        subIn.value = stxt.substring(0, 40); 
      } 
      popover.style.display = 'none'; 
      sync(); 
    }); 
  }); 

  function openCartDrawerOrRedirect() { 
    const cartDrawer = document.querySelector('cart-drawer'); 
    if (cartDrawer && typeof cartDrawer.show === 'function') { 
      cartDrawer.show(); 
    } else { 
      window.location.href = '/cart'; 
    } 
  } 

  async function handleAddToCart() { 
    if (selectedPlaqueId && !headIn.value.trim()) { alert('Please enter a headline.'); return; } 
    atcBtn.disabled = true; 
    atcBtn.innerText = 'Adding...'; 

    const drawerElement = document.querySelector('cart-drawer');
    const drawerSectionId = drawerElement ? drawerElement.getAttribute('section') : null;

    const items = [{ id: parseInt(container.dataset.cubeId), quantity: 1, properties: {} }]; 
    if (selectedPlaqueId) items.push({ id: selectedPlaqueId, quantity: 1, properties: { 'Headline': headIn.value.toUpperCase(), 'Sub-Headline': subIn.value.toUpperCase() } }); 
    if (selectedCoverId) items.push({ id: selectedCoverId, quantity: 1 }); 

    try { 
      const res = await fetch('/cart/add.js', { 
        method: 'POST', 
        headers: { 'Content-Type': 'application/json' }, 
        body: JSON.stringify({ 
          items: items,
          sections: drawerSectionId,
          attributes: { 'global_atc': 'true' }
        }) 
      });
      const cart = await res.json(); 
      
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } })); 
      document.dispatchEvent(new Event('cart:refresh')); 

      const modalElement = document.getElementById('global-atc-modal');
      if (modalElement) modalElement.removeAttribute('open'); 

      openCartDrawerOrRedirect(); 

      setTimeout(() => {
        atcBtn.disabled = false; 
        atcBtn.innerText = 'Add to cart';
      }, 500);

    } catch (e) { 
      alert('Error adding to cart'); 
      atcBtn.disabled = false; 
      atcBtn.innerText = 'Add to cart'; 
    } 
  }

  atcBtn.addEventListener('click', handleAddToCart); 

  container.querySelectorAll('.plaque-option').forEach(btn => btn.addEventListener('click', () => { 
    container.querySelectorAll('.plaque-option').forEach(b => b.classList.remove('active')); 
    btn.classList.add('active'); 

    selectedPlaqueId = btn.dataset.variantId ? parseInt(btn.dataset.variantId) : null; 

    if (selectedPlaqueId) {
      fireCustomizeProduct(getAddOnByVariantId(selectedPlaqueId), 'engraved_plaque');
    }

    plaqueFields.style.display = selectedPlaqueId ? 'block' : 'none'; 

    const isSteel = btn.classList.contains('plaque-steel'); 
    container.querySelector('.pm-preview-steel').style.opacity = isSteel ? '1' : '0'; 
    container.querySelector('.pm-preview-brass').style.opacity = isSteel ? '0' : '1'; 

    sync(); 
  }));

  container.querySelectorAll('.displaycover-option').forEach(btn => btn.addEventListener('click', (e) => { 
    container.querySelectorAll('.displaycover-option').forEach(b => b.classList.remove('active')); 
    e.currentTarget.classList.add('active'); 

    selectedCoverId = e.currentTarget.dataset.variantId ? parseInt(e.currentTarget.dataset.variantId) : null; 

    if (selectedCoverId) {
      fireCustomizeProduct(getAddOnByVariantId(selectedCoverId), 'display_cover');
    }
  }));

  [headIn, subIn].forEach(el => el.addEventListener('input', sync));
  document.addEventListener('click', () => popovers.forEach(p => p.style.display = 'none')); 
  
  fireModalViewItem();
  sync();
};  

